<template>
  <div class="language-switcher">
    <ButtonGhost
      v-for="language of languages"
      :key="language.label"
      :label="language.label"
      white
      :class="[{ active: locale === language.value }]"
      @onClick="selectLanguage(language.value)"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import useTvaMq from "@/plugins/tvaMq.js";
import { useI18n } from "vue-i18n";

import ButtonGhost from "../atoms/ButtonGhost.vue";
import { useRouter, useRoute } from "vue-router";

defineProps({
  languages: {
    type: Array,
    default: () => [],
  },
});

const router = useRouter();
const route = useRoute();
const i18n = useI18n();
const { t } = useI18n();
const { $tvaMq } = useTvaMq();

const largeScreen = computed(() => ["desktop", "large"].includes($tvaMq.value));
const locale = computed(() => i18n.locale.value);

function selectLanguage(newLanguage) {
  const pageParamTranslation = t(`translation.${route.params.page}`);

  if (process.env.NODE_ENV === "development") {
    i18n.locale.value = newLanguage.toLowerCase();
    document
      .querySelector("html")
      .setAttribute("lang", newLanguage.toLowerCase());

    router.push({ params: { page: pageParamTranslation }, query: route.query });
  } else {
    const currentLanguage = i18n.locale.value;
    const specificPath = window.location.pathname.replace(
      process.env["VUE_APP_PATH_" + currentLanguage.toUpperCase()],
      ""
    );

    window.location.href =
      process.env["VUE_APP_PATH_" + newLanguage.toUpperCase()] +
      specificPath.replace(route.params.page, pageParamTranslation);
  }
}
</script>

<style lang="scss" scoped>
.language-switcher {
  width: 100%;
  line-height: 100% !important;

  > * {
    opacity: 0.6;
    transition: opacity 0.3s ease;
    padding: 0;

    &.active {
      opacity: 1;
    }

    &:first-child {
      padding-right: 0.5rem;
      border-right: 1px solid var(--color-white-60);
    }
    &:last-child {
      padding-left: 0.5rem;
    }
  }
}
</style>
